import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import MyLeadsCRUDActions from '../actions/MyLeadsCRUDActions';
import { MyLeadsState } from '../interfaces/myLeads';

const initialState: MyLeadsState = {
  busy: false,
  searchOptions: {},
  contacts: [],
  pagination: {
    total: 0,
    page: 0,
    perPage: 50,
  },
};

export default function leads(state = initialState, action: any) {
  switch (action.type) {
    case MyLeadsCRUDActions.busyAction:
      return setBusy(state);
    case MyLeadsCRUDActions.unbusyAction:
      return setUnBusy(state);
    case MyLeadsCRUDActions.retrievedAllAction:
      return {
        ...state,
        busy: false,
        searchOptions: action.entities,
      };
    case MyLeadsCRUDActions.retrieveLeadsBySearchAttributes: {
      const { contacts, pagination } = action.payload;
      return {
        ...state,
        contacts,
        pagination,
        busy: false,
      };
    }
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
